import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/.dev/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/.dev/markdoc/tags.tsx'
import * as nodes from '/vercel/path0/.dev/markdoc/nodes.tsx'
import * as functions from '/vercel/path0/.dev/markdoc/functions.ts'
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Add Row\ndescription: Add a new row to any table in your project.\nslug: add-row\n---\n\nThe Add Row action allows you to add a row to any sheet in your project.\n\n{% figure src=\"/docs/reference/actions/add-row/Screen%20Shot%202020-11-16%20at%2012.10.14%20PM.png\" caption=\"Configuring Add Row Action\" /%}\n";
const filepath = "/reference/actions/add-row.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
